import React from 'react';
const LoadCardLeft = props => {
	const { load } = props;

	return <div className="load-card-left-side">
		<div className='mr-2 target-eg-name'> {load.targetEquipmentGroupName ? load.targetEquipmentGroupName : ""} </div>
		{load.transportEquipmentGroupName && <i className="fa fa-long-arrow-down i-arrow mr-2 mt-1" aria-hidden="true" />}
		{load.transportEquipmentGroupName && <div className='transport-eg-name'>{load.transportEquipmentGroupName}</div>}
		{load.transportOperatorName && <div className='transport-operator-name'>{`(${load.transportOperatorName})`}</div>}
		<div className='text-center'>
			<p className='mb-1' style={{ fontSize: "12px" }}>LOADS</p>
			<p className='mb-1 load_no'>{load.loadNo}</p>
		</div>
		<div className="estimated-load-capacity"></div>
	</div>;
};

export default LoadCardLeft;